// Fonction de validation des formules avec données fictives
export const validateFormula = (formula, availableFields = []) => {
  if (!formula || !formula.trim()) {
    return { isValid: true, error: null };
  }

  try {
    // Créer des données fictives pour tester la formule
    const testData = {};

    // Ajouter des valeurs fictives pour tous les champs disponibles
    availableFields.forEach(field => {
      switch (field.type) {
        case 'number':
          testData[field.key] = Math.random() * 100;
          break;
        case 'text':
          testData[field.key] = `test_${field.key}`;
          break;
        case 'date':
          testData[field.key] = new Date();
          break;
        case 'checkbox':
          testData[field.key] = Math.random() > 0.5;
          break;
        default:
          testData[field.key] = `test_${field.key}`;
      }
    });

    // Ajouter quelques valeurs par défaut communes
    testData['prix_ht'] = 100;
    testData['tva'] = 20;
    testData['quantite'] = 5;
    testData['nom_client'] = 'Dupont';
    testData['prenom'] = 'Jean';
    testData['date'] = new Date();
    testData['age'] = 30;

    // Importer evaluateFormula dynamiquement pour éviter les dépendances circulaires
    const { evaluateFormula } = require('../utils/formulas');

    // Tester la formule
    const result = evaluateFormula(formula, testData);

    // Vérifier que le résultat n'est pas undefined ou null (sauf si c'est intentionnel)
    if (result === undefined) {
      return {
        isValid: false,
        error: "La formule retourne undefined. Vérifiez la syntaxe."
      };
    }

    return { isValid: true, error: null };

  } catch (error) {
    return {
      isValid: false,
      error: error.message || "Erreur de syntaxe dans la formule"
    };
  }
};

// Fonction pour extraire les variables utilisées dans une formule
export const extractVariablesFromFormula = (formula) => {
  if (!formula) return [];

  // Regex pour trouver les variables (mots suivis de parenthèses ou non, mais pas des fonctions connues)
  const functionNames = [
    'SUM', 'ROUND', 'CONCAT', 'IF', 'MAX', 'MIN', 'UPPER', 'LOWER', 'LEN',
    'TODAY', 'YEAR', 'MONTH', 'DAYS', 'NUMTOTEXT', 'DATETOTEXT', 'EQUALS',
    'CONTAINS', 'IN', 'IFNULL', 'WHEN', 'PICKFROMCSV'
  ];

  const functionRegex = new RegExp(`\\b(${functionNames.join('|')})\\b`, 'gi');

  // Remplacer les appels de fonctions pour ne pas les confondre avec des variables
  let cleanedFormula = formula.replace(functionRegex, '');

  // Trouver tous les mots qui pourraient être des variables
  const variableRegex = /\b[a-zA-Z_][a-zA-Z0-9_]*(\.[a-zA-Z_][a-zA-Z0-9_]*)*\b/g;
  const matches = cleanedFormula.match(variableRegex) || [];

  // Filtrer les mots réservés et retourner uniques
  const reservedWords = ['true', 'false', 'null', 'undefined'];
  return [...new Set(matches.filter(word => !reservedWords.includes(word.toLowerCase())))];
};
